import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UI_SCOPE_TOGGLE_OPTIONS } from '../../constants/ui-scope-toggle-options.constants';
import { UiScopeToggleCounts } from '../../types/ui-scope-toggle-counts.interface';
import { UiScopeToggleOption } from '../../types/ui-scope-toggle-option.interface';
import { UiScopeValue } from '../../types/ui-scope-value.type';

type UiScopeToggleViewOption = {
  readonly value: UiScopeValue;
  readonly label: string;
  readonly iconLabel: string;
  readonly disabled: boolean;
  readonly selected: boolean;
  readonly count: number | null;
};

@Component({
  selector: 'ui-scope-toggle',
  imports: [],
  templateUrl: './ui-scope-toggle.component.html',
  styleUrl: './ui-scope-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiScopeToggleComponent {
  public readonly value: InputSignal<UiScopeValue> = input<UiScopeValue>('me');
  public readonly counts: InputSignal<UiScopeToggleCounts | null> = input<UiScopeToggleCounts | null>(null);
  public readonly options: InputSignal<readonly UiScopeToggleOption[]> =
    input<readonly UiScopeToggleOption[]>(UI_SCOPE_TOGGLE_OPTIONS);
  public readonly ariaLabel: InputSignal<string> = input<string>('Zakres');
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly valueChange: OutputEmitterRef<UiScopeValue> = output<UiScopeValue>();

  protected readonly viewOptions: Signal<readonly UiScopeToggleViewOption[]> = computed(
    (): readonly UiScopeToggleViewOption[] => {
      const selectedValue: UiScopeValue = this.value();
      const counts: UiScopeToggleCounts | null = this.counts();

      return this.options().map(
        (option: UiScopeToggleOption): UiScopeToggleViewOption => ({
          value: option.value,
          label: option.label,
          iconLabel: option.iconLabel,
          disabled: option.disabled === true,
          selected: option.value === selectedValue,
          count: counts?.[option.value] ?? null,
        }),
      );
    },
  );

  protected handleOptionSelected(option: UiScopeToggleViewOption, event: MouseEvent): void {
    if (this.disabled() || option.disabled) {
      event.preventDefault();
      return;
    }

    this.valueChange.emit(option.value);
  }
}
